export enum EFlag {
	splashHidden = "splashHidden",
	patchesDone = "patchesDone",
	appInitialized = "appInitialized",
	/** Flag pour arrêter le service de tâches en arrière plan. */
	stopBackgroundTaskService = "stopBTS",
	/** Flag indiquant que l'application est prête à être consommée. */
	appAvailable = "appAvailable"
}